<template>
  <div id="app">
    <!-- <div id="nav">
      <p @click="goTASMax">TASMax</p> |
      <p @click="goTASMini">TASMini</p> |
      <p @click="goSRM">SRM</p> |
      <p @click="goBMS">BMS</p>
    </div>
    <a-layout style="padding: 0 24px 24px">
      <a-breadcrumb style="margin: 16px 0">
        <a-breadcrumb-item>Home</a-breadcrumb-item>
        <a-breadcrumb-item>List</a-breadcrumb-item>
        <a-breadcrumb-item>App</a-breadcrumb-item>
      </a-breadcrumb>
      <a-layout-content
        :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }"
      >

      </a-layout-content>
    </a-layout> -->
    <a-config-provider :locale="locale">
      <router-view ></router-view>
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  data(){
    return{
      locale: zhCN,
    }
  }
  // methods: {
  //   goTASMax () {
  //     window.location.href = 'http://localhost:8091/'
  //   },
  //   goTASMini () {
  //     window.location.href = 'http://localhost:8092/'
  //   },
  //   goSRM () {
  //     window.location.href = 'http://localhost:8093/'
  //   },
  //   goBMS () {
  //     window.location.href = 'http://localhost:8094/'
  //   }
  // }
}
</script>
<style lang="less">
#nav {
  display: flex;
  justify-content: center;
  font-size: 36px;
}
</style>



// WEBPACK FOOTER //
// src/Master/App.vue